<template>
  <div class="v2-blog">
    <app-section theme="nude grid-dark" class="top-section">
      <div class="row">
        <div class="col-12 col-xl-10 m-auto">
          <app-frame>
            <img :src="welcomePoster" :alt="`Ersties Blog`" />
          </app-frame>
          <div class="description-block">
            <p class="pt-2">
              {{
                t(
                  "We believe in a new kind of pornography. Films filled with passion, joy and natural beauty - made by women, putting women’s pleasure first… On the Ersties blog you will find all kinds of women living out different fantasies and joyfully sharing their erotic experiences. This is porn…done differently",
                )
              }}
            </p>

            <div class="d-flex justify-content-center">
              <button v-modal.modal-signup class="btn btn-primary wide" @click="sendRegistrationTrack">
                {{ t("Join Now") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </app-section>
    <app-section theme="peach" class="search-section" :wave-top="true">
      <blog-search-v2 :category="category" :title="title" @on-change-title="onChangeTitle" @on-change-category="onChangeCategory" />
      <blog-list-v2 :posts="posts" :page="page" :pages="pages" @on-click-more="onClickMore" />
    </app-section>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { updateUrl } from "@/utils/urlHelper";
import blogService from "@/api/services/blogService";
import { amplitudePageViewTrack, amplitudeRegistrationButtonClickTrack } from "@/utils/amplitude";
import { changeLanguage } from "@/i18n.js";
import { BlogPost } from "@/interfaces/Blog/BlogPost.ts";
import BlogListV2 from "@/components/v2/blog-list/index.vue";
import AppFrame from "@/components/v2/app-frame/index.vue";
import AppSection from "@/components/v2/section/index.vue";
import BlogSearchV2 from "@/components/v2/blog-search/index.vue";
import { useRoleStore } from "@/store/role.ts";
import { ROLE_CENSORED_TOKEN } from "@/utils/variables.ts";
import { getRandomCensoredImage } from "@/utils/censorHelper.ts";
import welcomeDeImage from "@/assets/images/blog/welcome_de.jpg";
import welcomeEnImage from "@/assets/images/blog/welcome_en.jpg";

defineOptions({
  name: "blog",
});

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  category: {
    type: String,
    default: null,
  },
});

const route = useRoute();
const router = useRouter();
const { locale, t } = useI18n();

const posts = ref<BlogPost[]>([]);
const page = ref(1);
const pages = ref(1);
const total = ref(0);
const currentTitle = ref(props.title);
const currentCategory = ref(props.category);

const welcomePoster = computed(() => {
  return useRoleStore().hasRole(ROLE_CENSORED_TOKEN) ? getRandomCensoredImage() : locale.value === "de" ? welcomeDeImage : welcomeEnImage;
});

watch(locale, (val) => {
  router.replace({
    ...route,
    ...{ path: val === "de" ? "/lecker_blog" : "/blog" },
  });
});

watch(
  route,
  () => {
    posts.value = [];
    page.value = 1;
    pages.value = 1;
    load();
  },
  { deep: true },
);

const sendRegistrationTrack = () => {
  amplitudeRegistrationButtonClickTrack("blog");
};

const onClickMore = () => {
  if (page.value < pages.value) {
    page.value++;
    load();
  }
};

function updateRoute() {
  updateUrl(
    route,
    {
      title: currentTitle.value?.length > 0 ? currentTitle.value : null,
      category: currentCategory.value?.length > 0 ? currentCategory.value : null,
    },
    null,
    "#",
  );
}

function onChangeCategory(category: string) {
  currentCategory.value = category;
  updateRoute();
}

function onChangeTitle(title: string) {
  currentTitle.value = title;
  updateRoute();
}

async function load() {
  const res = await blogService.getList(locale.value, page.value, props.title, props.category);
  posts.value = [...posts.value, ...res.posts];
  pages.value = res.pages;
  total.value = res.total;
}

onMounted(() => {
  changeLanguage(route.path === "/lecker_blog" ? "de" : locale.value);
  load();
  amplitudePageViewTrack();
});
</script>

<style lang="scss">
@import "./index";
</style>
